import { useDispatch, useSelector } from 'react-redux';
import { StateShape as ReduxStateShape } from '../../reducers';
import { actionCreators as templateEditorActionCreators } from '../../reducers/templateEditor';
import { actionCreators } from '../../reducers/resources';

const SelectFundsButton = () => {
    const { isShowFundsPicker } = useSelector((state: ReduxStateShape) => ({
        ...state.templateEditor,
    }));
    const dispatch = useDispatch();

    return (
        <div className="select-funds-button">
            <button
                onClick={() => {
                    dispatch(actionCreators.setselectedSchemaId('root_selectedFunds'));
                    dispatch(templateEditorActionCreators.setIsShowFundsPicker(!isShowFundsPicker));
                }}
            >
                {'Select Funds'}
            </button>
        </div>
    );
};

export default SelectFundsButton;
